<template>
    <ModalFormCard :action="action" class="modal-default md:!w-[500px]" formCSS="px-6 pb-6 pt-2" v-bind="{ errors, saving }">
        <template #title>{{ $help.capitalizeFirstLetter(event.label()) }} details</template>

        <div class="flex pt-6">
            <div class="w-6 h-6 flex justify-center items-center">
                <component :is="event.eventIcon()" />
            </div>

            <p class="text-17 font-semibold pl-2">{{ event.title }}</p>
        </div>

        <p class="text-15 text-grey-900 pl-8 pt-1.5 pb-3">{{ event.description }}</p>

        <div class="flex items-center border-t border-grey-500 py-3">
            <!-- <div> -->
            <DropdownV2
                class=""
                buttonCSS="items-center"
                forceSide="left"
                :menuSpace="8"
                :disabled="event.statusString() == 'Done'"
            >
                <template #button="{ open }" }>
                    <!-- <component :is="event.statusIconName()" /> -->
                    <!-- <IconTime class="w-4.5 h-4.5" :class="[event.statusClass('stroke')]" /> -->
                     <div class='w-6 flex items-center justify-center'>
                        <div class="w-2 h-2 rounded-full" :class="[event.statusClass()]" />
                    </div>
                    <p class="text-14 capitalize pl-2">{{ event.statusString() }}</p>
                    <IconArrowSmallDown
                        class="stroke-grey-900"
                        v-if="event.statusString() != 'Done'"
                    />
                </template>

                <template #menu>
                    <div class="table-multi-select-menu bg-black min-w-[210px]">
                        <p class="text-grey-800 text-14 pb-1.5 px-4 pt-0.5">Event options</p>
                        <button
                            data-close
                            @click="() => {
                                event.complete()
                                $emit('close')
                            }"
                            v-if="event.statusString() != 'Completed' && event.statusString() != 'Done' && event.statusString() != 'Cancelled'"
                        >
                            {{ event.appointment == 1 ? 'Cancel event' : 'Mark as done' }}
                        </button>
                        <button data-close @click="() => {
                            event.clearComplete()
                            $emit('close')
                        }" v-else>{{ event.appointment == 1 ? 'Undo cancel' : 'Undo done' }}</button>
                        <button data-close @click="() => {
                            event.destroy()
                            $emit('close')
                        }">Delete {{ event.appointment == 1 ? 'event' : 'task' }}</button>
                    </div>
                </template>
            </DropdownV2>

            <!-- <p class="text-14 text-grey-900 pl-4" v-if="event.completed_at != null">
                {{
                    $help.formatDateTime(event.completed_at, {
                        date: true,
                        time: true,
                    })
                }}
            </p> -->
        </div>

        <div class="flex border-t border-grey-500 py-3">
            <div class='w-6 flex justify-center'>
                <component is="IconTime" class="w-4.5 h-4.5 stroke-grey-900 shrink-0 mt-[3px]" />
            </div>

            <div class="pl-2">
                <p class="text-15">
                    {{ $moment(event.starts_at).format('HH:mm') }}
                    <!-- <template v-if="event.duration != null">- {{ $moment(event.virtual_ends_at).format('h:mma') }}</template> -->
                </p>
                <p class="text-14 text-grey-900">
                    {{ this.$moment(event.starts_at).format('DD/MM/YYYY') }}
                </p>
            </div>

            <template v-if="event.virtual_ends_at != event.starts_at">
                <div class="flex items-center">
                    <IconArrowRightFull class="shrink-0 mx-8" />
                </div>

                <div class="pl-2 pt-px">
                    <p class="text-15">
                        {{ $moment(event.virtual_ends_at).format('HH:mm') }}
                    </p>
                    <p class="text-14 text-grey-900">
                        {{ this.$moment(event.virtual_ends_at).format('DD/MM/YYYY') }}
                    </p>
                </div>
            </template>
        </div>

        <div class="flex items-center border-t border-grey-500 py-3" v-if="event.virtual_ends_at != event.starts_at">
            <div class='w-6 flex items-center justify-center'>
                <component is="IconDuration" class="stroke-grey-900 shrink-0 w-4.5 h-4.5 mt-[1px]" />
            </div> 

            <div class="pl-2">
                <p class="text-15">{{ event.durationHuman() }}</p>
            </div>
        </div>

        <div class="border-t border-grey-500 py-3">
            <!-- border-y border-grey-500 pb-4 mt-4 -->
            <div v-for="link in event.links()" class="flex items-center pb-2">
                <div class='w-6 flex items-center justify-center'>
                    <component
                        :is="link.icon"
                        class="w-4.5 h-4.5 shrink-0 mt-[3px]"
                        :class="{
                            'stroke-grey-900': link.type != 'deal',
                        }"
                    />
                </div>

                <div class="pl-2">
                    <NuxtLink v-if="link.type == 'company'" :to="'/company/'+link.data.id+'/company'" 
                        class="link-text text-15" v-text='link.data.getName()' @click="close"
                    />

                    <NuxtLink v-if="link.type == 'contact'"  :to="link.data.view()" 
                        class="link-text text-15" v-text='link.data.fullName()' @click="close"
                    />

                    <NuxtLink v-if="link.type == 'deal'" :to="link.data.view()" 
                        class="link-text text-15" v-text='link.data.getName()' @click="close"
                    />
                </div>
            </div>
        </div>

        <div class="modal-buttons">
            <!-- <button class="button-black-outline h-12" @click="$emit('close')">Back to all events</button> -->
            <button class="button-black default h-12 col-span-2" @click="event.edit()">Edit {{ event.label() }}</button>

            <div class="col-span-2">
                <button class="button-purple default text-left h-12 w-fit">
                    <NuxtLink :to="editingModel.calendarLink()" v-text="'View calendar'" @click="$emit('close')" />
                </button>
            </div>
        </div>
    </ModalFormCard>
</template>

<script>
import Event from '~/models/event.js'
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    methods: {
        close() {
            this.$event.$emit('modal-close')
        }
    },

    computed: {
        event() {
            // console.log(this)
            return new Event(this.editingModel, {
                vue: this,
            })
        },
    },
}
</script>
